import { gql } from '@apollo/client'

export const DELETE_USER_VEHICLE = gql`
    mutation delete_user_vehicle($request: DeleteUserVehicleRequest!) {
        delete_user_vehicle(request: $request) {
            success
        }
    }
`
